"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECEIPT_MAPPING = {
    prefix: 'receipt',
    email: {
        path: '/email',
    },
    pdf: {
        path: '/pdf',
    },
};
